import React, { memo, useEffect, useState } from "react";
import moment from "moment/moment";
import StartStopbtn from "../../components/common-components/StartStopbtn";
import buildCalender from "./build";
import CalendarHeader from "./Header";
import dayStyles, { afterToday, beforeSpecificDate, beforeToday } from "./styles";

const Calendar = ({
    specificDate,
    classNames: { parentDiv, header, dayNames, weekParent, dayHolder, singleDay },

    changeOptions: { classNames, btnsText, btnFuncions, btnStatus }
}) => {
    const value = moment();
    const [calendar, setCalendar] = useState();
    const [selectedDate, setSelectedDate] = useState(value);
    useEffect(() => {
        setCalendar(buildCalender(selectedDate));
    }, [selectedDate]);
    return (
        <div className={parentDiv}>
            <CalendarHeader value={selectedDate} setValue={setSelectedDate} header={header} />
            <div className={dayNames?.holder}>
                {["S", "M", "T", "W", "T", "F", "S"]?.map((d) => (
                    <div className={dayNames?.dayName}>{d}</div>
                ))}
            </div>
            {calendar?.map((week) => {
                return (
                    <div key={week} className={weekParent}>
                        {week?.map((day) => {
                            return (
                                <div
                                    onClick={() =>
                                        !afterToday(day) &&
                                        !beforeSpecificDate(day, specificDate) &&
                                        setSelectedDate(day)
                                    }
                                    key={day}
                                    className={dayHolder}>
                                    <div
                                        className={
                                            dayStyles({
                                                day,
                                                selectedDate,
                                                singleDay,
                                                specificDate
                                            }) + singleDay
                                        }>
                                        {day?.format("D")?.toString()}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}

            <StartStopbtn
                positiveText={btnsText?.positive}
                negativeText={btnsText?.negative}
                positiveClassName={classNames?.positive}
                negativeClassName={classNames?.negative}
                parentDivClassName={classNames?.parentDiv}
                positiveFunc={() => btnFuncions?.positive(selectedDate)}
                negativeFunc={() => btnFuncions?.negative()}
            />
        </div>
    );
};
export default memo(Calendar, (oldProps, newProps) => {
    if (
        oldProps.specificDate !== newProps.specificDate ||
        oldProps.classNames.parentDiv !== newProps.classNames.parentDiv
    ) {
        return false;
    }
    return true;
});
